export default __webpack_public_path__ + "static/media/siemens.502f5a14.png";